import React, { useState, useEffect }  from "react";
import MyOrderItem from './MyOrderItem';
import MyCount from '../../../components/MyPage/MyCount';
import { useOutletContext } from "react-router-dom";
import instance from "../../../services/services";
import { MY_PAGE_MAIN_LIST_URL } from "../../../utils/urls";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../hooks/useLanguage";

function MyOrderList(){
  const { t } = useLanguage();
    const navigate = useNavigate();
    const { myInfo } = useOutletContext();
    const [isTablet, setIsTablet] = useState(false);
    const [visitList, setVisitList] = useState([]);
    const [parcelList, setParcelList] = useState([]);
    const [estimateList, setEstimateList] = useState([]);
    const [saleList, setSaleList] = useState([]);
    const [managerRatingPoint, setManagerRatingPoint] = useState(0);
    // 모바일 체크
    useEffect(() => {
      const checkTablet = () => {
        setIsTablet(window.innerWidth < 768);
      };
      
      checkTablet();
      window.addEventListener('resize', checkTablet);
      
      return () => window.removeEventListener('resize', checkTablet);
    }, []);

    // 매장 방문 리스트, 택배 수령 리스트
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await instance.post(MY_PAGE_MAIN_LIST_URL);
          setManagerRatingPoint(response.data.data.manager_rating_point);
          setVisitList(response.data.data.data.visit);
          setParcelList(response.data.data.data.parcel);
          setEstimateList(response.data.data.data.estimate);
          setSaleList(response.data.data.data.sale);
        } catch (error) {
          console.error("데이터 가져오기 실패:", error);
        }
      };
      fetchData();
    }, []);

    const handleOrderDetail = (type) => {
      navigate(`/myPage/orderManagement?type=${type}`);
    };
    

    
  return(
    <div>

      {/* 장바구니 / 관심상품 / 쿠폰 */}
      <MyCount/>
      
      {!isTablet && (
        <>

        {/* 판매상품 외 주문 정보  ui 같습니다 */}  
          <div className="my_container">
            <div className="order_title">
              <div>
                <h3>{t('store_order_management2')}</h3>
              </div>
              <button
                type="button"
                className="more_text_btn flex-center-2"
                onClick={() => handleOrderDetail('visit')}
              >
                {t('see_more')}
              </button>
            </div>
            {/* manage_list */}
            <MyOrderItem type="visit" orderList={visitList} memberSeq={myInfo?.member_seq} point={managerRatingPoint}/>
          </div>

          <div className="my_container">
            <div className="order_title">
              <div>
                <h3>{t('delivery_management')}</h3>
              </div>
              <button
                type="button"
                className="more_text_btn flex-center-2"
                onClick={() => handleOrderDetail('parcel')}
              >
                {t('see_more')}
              </button>
            </div>
            {/* manage_list */}
            <MyOrderItem type="parcel" orderList={parcelList} memberSeq={myInfo?.member_seq} point={managerRatingPoint}/>
          </div>

          <div className="my_container">
            <div className="order_title">
              <div>
                <h3>{t('quotation_management')}</h3>
              </div>
              <button
                type="button"
                className="more_text_btn flex-center-2"
                onClick={() => handleOrderDetail('estimate')}
              >
                {t('see_more')}
              </button>
            </div>
            {/* manage_list */}
            <MyOrderItem type="estimate" orderList={estimateList} memberSeq={myInfo?.member_seq} point={managerRatingPoint}/>
          </div>

        {/* 판매상품 ui */}  
          <div className="my_container">
            <div className="order_title">
              <div>
                <h3>{t('sale_product_order_management')}</h3>
              </div>
              <button
                type="button"
                className="more_text_btn flex-center-2"
                onClick={() => handleOrderDetail('sale')}
              >
                {t('see_more')}
              </button>
            </div>
            <MyOrderItem type="sale" orderList={saleList} memberSeq={myInfo?.member_seq} point={managerRatingPoint}/>

          </div>
        </>
      )}

    </div>
  )
};

export default MyOrderList;